export default "__VITE_ASSET__BtARcLUD__"